<template>
<form @submit.prevent="submit" id="deposit_create_form">
    <kt-form-section is_first>
        <kt-row>
            <kt-col lg="6" md="6" xs="12">
                <kt-form-group>
                    <kt-form-label for="farsi_name">
                        {{ $t('label.farsi_name') }}
                    </kt-form-label>
                    <kt-form-control
                        id="farsi_name"
                        name="farsi_name"
                        v-model="form_data.farsi_name"
                    >
                    </kt-form-control>
                </kt-form-group>
            </kt-col>

            <kt-col lg="6" md="6" xs="12">
                <kt-form-group>
                    <kt-form-label for="english_name">
                        {{ $t('label.english_name') }}
                    </kt-form-label>
                    <kt-form-control
                        id="english_name"
                        name="english_name"
                        v-model="form_data.english_name"
                        dir="ltr"
                    >
                    </kt-form-control>
                </kt-form-group>
            </kt-col>
        </kt-row>
    </kt-form-section>

    <kt-form-section>
        <kt-row>
          <kt-col lg="6" md="6" xs="12">
            <kt-form-group>
              <kt-form-label for="callback_address">
                {{ $t('label.callback_address') }}
              </kt-form-label>
              <kt-form-control
                  id="callback_address"
                  name="callback_address"
                  v-model="form_data.callback_address"
                  dir="ltr"
              >
              </kt-form-control>
            </kt-form-group>
          </kt-col>
            <kt-col lg="6" md="6" xs="12">
                <kt-form-group>
                    <kt-form-label>
                        {{ $t('label.logo') }}
                    </kt-form-label>
                    <kt-form-label for="logo_file" class="d-block btn btn-secondary btn-wide label-file">
                        <kt-icon type="fa" name="paperclip"></kt-icon>
                        {{ $t('gateway.btn.click_me') }}
                    </kt-form-label>
                    <input
                            @change="processLogoFile"
                            type="file"
                            class="custom-file-upload"
                            name="logo"
                            id="logo_file"
                            accept="image/png"
                    />
                </kt-form-group>
            </kt-col>
            <kt-col style="margin-bottom: 15px">
                <kt-col></kt-col>
                <kt-form-action class="mt-4">
                    <button
                            class="btn btn-md btn-primary btn-wide"
                            type="button"
                            data-toggle="modal"
                            data-target="#access-ips-modal"
                            id="access_ips_btn"
                    >
                        {{ $t('application.access_ips') }}
                    </button>
                </kt-form-action>
                <div id="access-ips-modal" class="modal fade" role="dialog"
                >
                    <div class="modal-dialog">
                        <!-- Modal content-->
                        <div class="modal-content" id="access-ips-modal-content">
                            <div class="modal-header">
                                <h4 class="modal-title">
                                    {{ $t('application.access_ips') }}
                                </h4>
                                <button type="button" class="close" data-dismiss="modal">&times;</button>
                            </div>
                            <div class="modal-body">

                                <div v-for="(access_ip,index) in form_data.access_ips" :key="index">
                                    <kt-row>
                                        <kt-col xs="7" sm="7">
                                            <kt-form-group>
                                                <kt-form-control :value="access_ip" dir="ltr"
                                                                 :name="'access_ips.'+index"
                                                                 v-model="form_data.access_ips[index]"
                                                                 :id="index"></kt-form-control>
                                            </kt-form-group>
                                        </kt-col>
                                        <kt-col xs="3" sm="3">
                                            <kt-form-group>
                                                <a @click="deleteAccessIp(index)"
                                                   class="w-100 h-100 p-2 pt-3 btn-sm btn btn-label-danger btn-bold float-right">
                                                    <i class="la la-trash-o"></i>
                                                    {{ $t('btn.delete') }}
                                                </a>
                                            </kt-form-group>
                                        </kt-col>
                                    </kt-row>
                                </div>
                                <kt-row id="add_access_ip">
                                    <kt-col xs="9" sm="9">
                                        <kt-form-group>
                                            <kt-form-control dir="ltr" v-model="new_access_ip"
                                                             name="new_access_ip"
                                                             id="new_access_ip"></kt-form-control>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="3" sm="3">
                                        <kt-form-group hor style="margin-right: 2%">
                                            <a style="padding-top: 10%" @click="addAccessIp()"
                                               class="btn btn-bold btn-sm btn-label-brand">
                                                <i class="la la-plus"></i> {{ $t('btn.add') }}
                                            </a>
                                        </kt-form-group>
                                    </kt-col>
                                </kt-row>
                            </div>
                        </div>
                    </div>
                </div>

            </kt-col>
        </kt-row>
    </kt-form-section>
    <kt-form-action class="mt-4">
        <kt-button
            class="btn-wide"
            size="md"
            variant="success"
            type="submit"
            v-bind:wide="true"
            id="submit_btn"
        >
            {{ $t('panel.profile.update.wizard.form.btn.submit') }}
        </kt-button>
    </kt-form-action>
</form>
</template>

<script>
import $ from 'jquery'
import { mapGetters, mapState } from 'vuex'
import { i18n } from '@/plugins/i18n'
import toastr from "toastr";

export default {
    props: {
        submit: {
            default: () => {},
            type: Function
        },
        form_data: {
            default() {
                return {}
            },
            type: Object
        }
    },
    data() {
        return {
            new_access_ip : null
        }
    },
    mounted() {
    },
    methods: {
        afterDispatch() {
            $('.kt-selectpicker').selectpicker({
                size: 4,
                liveSearch: true,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            })
        },
        processLogoFile(e) {
            this.form_data.logo = event.target.files[0]
        },
        addAccessIp() {
            if (this.form_data.access_ips.length == 0)
                this.form_data.access_ips = []
            var ip_regex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
            if (!ip_regex.test(this.new_access_ip))
                return this.toastr.error(i18n.t('application.message.invalid_ip_format'))

            for (var i = 0; i < this.form_data.access_ips.length; i++) {
                if (this.form_data.access_ips[i] === this.new_access_ip)
                    return this.toastr.error(i18n.t('application.message.ip_is_duplicate'))
            }

            this.form_data.access_ips.push(this.new_access_ip)
            if (this.form_data.access_ips.length >= 4)
                document.getElementById('add_access_ip').style.display = 'none'
            this.new_access_ip = null
        },
        deleteAccessIp(index) {
            this.form_data.access_ips.splice(index, 1)

            if (this.form_data.access_ips.length < 4)
                document.getElementById('add_access_ip').style.display = 'flex'
        },
    },
    computed: {
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }

            return toastr
        },
    },
}
</script>

<style scoped>
.label-file {
    border: 1px solid #ccc;
    width: fit-content;
    cursor: pointer;
    min-width: 200px;
}
input[type="file"]::-webkit-file-upload-button {
    visibility: hidden;
}
</style>